// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-button[data-v-8080a250]{font-family:Source Sans\\ 3;font-size:16px;font-style:normal;font-weight:400;line-height:23px;letter-spacing:.06em;margin-top:50px;color:#fff;text-transform:uppercase}.setting-button[data-v-8080a250]:hover{color:#ffc122}", ""]);
// Exports
module.exports = exports;
